import { useState } from "react";
import { account } from "../appWrite"; // Ensure Appwrite SDK is configured
import Navbar from "../components/Navbar";

// Request Password Reset Page
export default function RequestReset() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleRequest = async () => {
    try {
      await account.createRecovery(
        email,
        window.location.origin + "/reset-password"
      );
      setMessage("Check your email for a reset link.");
    } catch (error) {
      setMessage("Failed to send reset email.");
    }
  };

  return (
    <>
      <Navbar current="password" />
      <div className="flex min-h-screen items-center justify-center p-6 bg-gray-300">
        <div className="w-full max-w-md bg-white p-6 rounded-xl shadow-md">
          <h2 className="text-xl font-semibold text-center mb-4">
            Reset Your Password
          </h2>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full p-3 border rounded-lg focus:ring focus:ring-blue-300"
          />
          <button
            className="w-full py-1 md:py-2 px-3 mt-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
            onClick={handleRequest}
          >
            Send Reset Link
          </button>

          {message && (
            <p className="text-center text-sm text-gray-600 mt-2">{message}</p>
          )}
        </div>
      </div>
    </>
  );
}
